export const WHATSAPP_NUMBER = "447417390757";
export const WHATSAPP_MSG = "Hi BrandToBuilt! I'd like to get my business launch-ready.";

export const packages = [
  {
    id: "launch",
    name: "Launch",
    price: "£199",
    priceNote: "from",
    tagline: "Get online, fast.",
    hero: false,
    features: [
      "1-page website",
      "Mobile optimised",
      "Contact + WhatsApp button",
      "Basic SEO setup",
      "Live in 48 hours",
    ],
  },
  {
    id: "business",
    name: "Business",
    price: "£399",
    priceNote: "from",
    tagline: "A proper website.",
    hero: false,
    features: [
      "5-page website",
      "SEO optimised",
      "Enquiry & booking forms",
      "Google Business setup",
      "Live in 3 days",
    ],
  },
  {
    id: "brand-business",
    name: "Brand & Business",
    price: "£599",
    priceNote: "from",
    tagline: "Look established from day one.",
    hero: true,
    badge: "MOST POPULAR",
    features: [
      "5-page website",
      "Custom logo",
      "Mini brand kit (colours + fonts)",
      "Full SEO setup",
      "Google Business setup",
      "Live in 5 days",
    ],
  },
  {
    id: "launch-everything",
    name: "Launch Everything",
    price: "£799",
    priceNote: "one-off",
    tagline: "Your entire business, done.",
    hero: true,
    badge: "COMPLETE SETUP",
    features: [
      "Everything in Brand & Business",
      "Domain + business email",
      "Google Business Profile",
      "Social profiles created",
      "10 launch social posts",
      "Full SEO setup",
      "Live in 7 days",
    ],
  },
];

export const memberships = [
  {
    id: "care",
    name: "Website Care",
    price: "£19",
    per: "/month",
    features: ["Hosting", "SSL certificate", "Automatic backups", "Minor edits", "Technical maintenance"],
    highlight: false,
  },
  {
    id: "growth",
    name: "Business Growth",
    price: "£39",
    per: "/month",
    features: ["Everything in Care", "Monthly website updates", "SEO monitoring", "Google Business support", "Monthly social content"],
    highlight: true,
  },
  {
    id: "pro",
    name: "Business Pro",
    price: "£69",
    per: "/month",
    features: ["Everything in Growth", "8 social posts / month", "Monthly blog article", "SEO updates", "Lead capture + AI assistant"],
    highlight: false,
  },
];

export const addons = [
  { name: "Logo", price: "£79", lookup: "addon_logo" },
  { name: "Mini brand kit", price: "£149", lookup: "addon_brand_kit" },
  { name: "Domain", price: "£20–30/yr" },
  { name: "Business email", price: "£49/yr" },
  { name: "Google Business setup", price: "£99", lookup: "addon_google" },
  { name: "Extra page", price: "£49", lookup: "addon_extra_page" },
  { name: "Booking system", price: "£99", lookup: "addon_booking" },
  { name: "WhatsApp integration", price: "£29", lookup: "addon_whatsapp" },
  { name: "Social starter pack", price: "£99", lookup: "addon_social_starter" },
  { name: "10 social posts", price: "£79", lookup: "addon_social_posts" },
  { name: "Extra revision", price: "£29", lookup: "addon_revision" },
];

export const industries = [
  "Cleaners", "Beauty therapists", "Hairdressers", "Nail technicians",
  "Electricians", "Plumbers", "Builders", "Photographers",
  "Coaches", "Consultants", "Therapists", "Dog groomers",
  "Personal trainers", "Mobile businesses", "Tradespeople", "New startups",
];

export const manifesto = [
  {
    n: "01",
    title: "You talk.",
    body: "Tell us about your business in 60 seconds — by voice or text. Your name, what you do, where you are, and three businesses you like the look of. That's it.",
  },
  {
    n: "02",
    title: "We build.",
    body: "Our team + AI production engine create your brand, logo, colours, fonts and a complete website. Then we set up your domain, email, Google Business and socials.",
  },
  {
    n: "03",
    title: "You launch.",
    body: "Within 48 hours to 7 days (depending on your package) your business is live and looking established. A real human quality-checks everything before it goes out. Then you just show up and get customers.",
  },
];

export const faqs = [
  {
    q: "Is it really live in 48 hours?",
    a: "Depends on the package. Launch is live in 48 hours (a fast-track slot, limited to 2 per day), Business in 3 days, Brand & Business in 5 days, and Launch Everything in 7 days. The clock starts once we have everything we need from you.",
  },
  {
    q: "I'm not techy at all. Is that a problem?",
    a: "Not even slightly. That's exactly who we build for. You never touch WordPress, hosting, DNS or plugins. You talk, we sort everything. 'Just sort it for me' is the whole point.",
  },
  {
    q: "What if I don't have a logo or branding yet?",
    a: "Perfect — our Brand & Business and Launch Everything packages include a custom logo, colours and fonts, so you get a complete, professional brand from day one.",
  },
  {
    q: "Do you only build websites?",
    a: "No. We build your whole digital presence: website, branding, domain, business email, Google Business Profile and social profiles. It's a business-in-a-box, not just a website.",
  },
  {
    q: "What happens after launch?",
    a: "You can join a monthly care plan from £19/month for hosting, backups, edits and ongoing growth support — or take your site and run. No lock-in.",
  },
  {
    q: "Can you fix or redesign my existing website?",
    a: "Absolutely. Run our free Website Score to see where it stands, then we'll rebuild it properly. Redesigns start from £199.",
  },
];

export const testimonials = [
  {
    name: "Sarah M.",
    role: "Beauty therapist · Marlow",
    quote: "I described my business into my phone and two days later I had a website, a logo and a Google listing. It looks like I've been going for years.",
  },
  {
    name: "Dan R.",
    role: "Electrician · Reading",
    quote: "I'm rubbish with tech. They just sorted the lot — website, email, the WhatsApp button. Booked three jobs the first week it went live.",
  },
  {
    name: "Priya K.",
    role: "Dog groomer · Slough",
    quote: "The whole thing cost less than one month of what an agency quoted me, and it was ready by Friday. Honestly unreal.",
  },
];
